import AppIcon from "@/common/components/Icons/AppIcon";
import RouteCategoryIndex from "@/common/components/Routing/RouteCategoryIndex";
import { ROUTE_PATH } from "@/common/constants/routing";
import { EnvHelper } from "@/common/helpers/env";
import { useAuthorizationInfo } from "@/common/hooks/auth/useAuthorizationInfo";

export function AppAreasRouteCategoryIndex() {
  const authorizationInfo = useAuthorizationInfo();

  return (
    <RouteCategoryIndex
      direction='row'
      childrenLinks={[
        ...(EnvHelper.isDevelopmentAny
          ? [
              {
                icon: <AppIcon of='dev' />,
                title: "Dev",
                to: ROUTE_PATH.APP_AREA_DEV,
              },
            ]
          : []),
        ...(authorizationInfo?.hasFleetAppAccess
          ? [
              {
                icon: <AppIcon of='webApp' />,
                title: "Fleet app",
                to: ROUTE_PATH.APP_AREA_FLEET_APP,
              },
            ]
          : []),
        ...(authorizationInfo?.hasFleetCustomerAppAccess
          ? [
              {
                icon: <AppIcon of='webApp' />,
                title: "Fleet customer app",
                to: ROUTE_PATH.APP_AREA_FLEET_CUSTOMER,
              },
            ]
          : []),
        ...(authorizationInfo?.hasAdminAppAccess
          ? [
              {
                icon: <AppIcon of='webApp' />,
                title: "Admin app",
                to: ROUTE_PATH.APP_AREA_ADMIN,
              },
            ]
          : []),
      ]}
    />
  );
}
